import React, {Component} from 'react';
import {connect} from 'react-redux';
import wsClient from '../utils/wsClient';
import { inject, observer } from 'mobx-react'
import { reaction } from 'mobx'

//actions
import setChatWS from '../actions/chat/setChatWS';


class WebSockets extends Component {
  constructor(props) {
    super(props);
    this._ws=new wsClient({
      // url:`wss://${window.location.hostname}:${process.env.NODE_ENV === 'production'?8077:8047}`,
      url:`wss://${process.env.NODE_ENV === 'production'?`next.shelf.moe:9502`:`${window.location.hostname}:9501`}`,
      onOpen:(e)=>{
        console.log('on open!');
        // this._ws.auth();
        if(this.props.meStore.me.data) {
          this._ws.send({
            command: "auth_by_token",
            eva_token: this.props.meStore.me.data.eva_token
          });
        }
      }
    });
  
    this._ws.pushOnMessage("evaPrivateChat", (data)=>{
      if(data.data) {
        data.data.timestamp = new Date().getTime();
      }
      if(data.channel === 'evaPrivateChat') {
        // this.props.setChatWS(data.data);
        this.props.chatStore.ws_cmd=data.data;
        if(data.data.message=='new_messages' && !this.props.appStateStore.app_visible) {
          this.startBlinking();
        }
      }
    });
    
    this._ws.pushOnMessage("main", (message)=>{
      this.wsConnector(message);
    });
    
    this._ws.connect();

    this.reactions=[];
    this.reactions.push(reaction(()=>{ return this.props.appStateStore.app_visible },(visible)=>{
      if(!visible) {
        this.stopBlinking();
      }
    }));
    this.reactions.push(reaction(()=>{ return this.props.meStore.me.data },(me)=>{
      this._ws.disconnect();
      this._ws.connect();
    }));
  }
  startBlinking() {
    if(!this._blinkingInterval) {
      this._blinkingInterval = setInterval(() => {
        const doc = document.getElementById('faviconItem');
        const cur = doc.attributes.href.nodeValue;
        if (cur.indexOf('red') > -1) {
          doc.attributes.href.nodeValue = '/favicon.ico?appicon1'
        } else {
          doc.attributes.href.nodeValue = '/favicon-red.ico?appicon1'
        }
      }, 500);
    }
    //
  }
  stopBlinking() {
    if(this._blinkingInterval) {
      clearInterval(this._blinkingInterval);
      this._blinkingInterval=false;
      const doc=document.getElementById('faviconItem');
      doc.attributes.href.nodeValue='/favicon.ico?appicon1'
    }
    //faviconItem
  }
  wsConnector(data) {
    console.log('data',data);
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    app_visible:state.app_visible,
  }
}

// export default connect(mapStateToProps, { setChatWS })(WebSockets);
export default inject("meStore","appStateStore","chatStore")(observer(WebSockets));